import React from 'react';

const DisclosuresPanel = ({ disclosures, loading }) => {
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center py-12 px-4 gap-3 text-[var(--color-text-secondary,#666)]">
        <span className="w-8 h-8 border-[3px] border-gray-200 border-t-[var(--color-primary,#3b82f6)] rounded-full animate-spin"></span>
        <span>공시 정보 로딩 중...</span>
      </div>
    );
  }

  if (!disclosures || disclosures.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 px-4 gap-3 text-[var(--color-text-secondary,#666)]">
        <span className="text-5xl">📋</span>
        <p>공시 정보가 없습니다</p>
      </div>
    );
  }

  // 공시 유형별 색상 및 아이콘
  const getTypeStyle = (typeCode) => {
    const styles = {
      major: { color: '#ef4444', icon: '🔴', label: '주요사항' },
      quarterly: { color: '#3b82f6', icon: '📘', label: '분기보고서' },
      annual: { color: '#2563eb', icon: '📗', label: '사업보고서' },
      equity: { color: '#10b981', icon: '💹', label: '지분공시' },
      correction: { color: '#f59e0b', icon: '📝', label: '정정공시' },
      etc: { color: '#6b7280', icon: '📄', label: '기타' },
    };
    return styles[typeCode] || styles.etc;
  };

  // 날짜 포맷 (YYYY-MM-DD -> MM/DD)
  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const [year, month, day] = dateStr.split('-');
    return `${month}/${day}`;
  };

  // 날짜 포맷 (전체)
  const formatFullDate = (dateStr) => {
    if (!dateStr) return '-';
    const [year, month, day] = dateStr.split('-');
    return `${year}년 ${month}월 ${day}일`;
  };

  return (
    <div className="w-full max-w-full py-4">
      <div className="flex flex-col gap-3">
        {disclosures.map((disclosure) => {
          const typeStyle = getTypeStyle(disclosure.typeCode);
          return (
            <a
              key={disclosure.id}
              href={disclosure.link}
              target="_blank"
              rel="noopener noreferrer"
              className="block p-4 bg-[var(--color-surface,#f8fafc)] border border-[var(--color-border,#e2e8f0)] rounded-lg no-underline text-inherit transition-all duration-200 hover:bg-white hover:border-[var(--color-primary,#3b82f6)] hover:shadow-md hover:-translate-y-px"
            >
              <div className="flex justify-between items-center mb-2 gap-2">
                <span
                  className="inline-flex items-center gap-1 py-1 px-2.5 text-xs font-medium rounded whitespace-nowrap"
                  style={{
                    backgroundColor: `${typeStyle.color}15`,
                    color: typeStyle.color,
                    border: `1px solid ${typeStyle.color}40`
                  }}
                >
                  {typeStyle.icon} {typeStyle.label}
                </span>
                <span className="text-[13px] text-[var(--color-text-secondary,#666)] font-medium">{formatDate(disclosure.date)}</span>
              </div>
              <h3 className="text-sm font-medium text-[var(--color-text-primary,#1a1a1a)] m-0 mb-2 leading-normal overflow-hidden line-clamp-2">{disclosure.title}</h3>
              <div className="flex justify-between items-center pt-2 border-t border-[var(--color-border,#e2e8f0)]">
                <span className="text-xs text-[var(--color-text-tertiary,#9ca3af)]">{formatFullDate(disclosure.date)}</span>
                <span className="text-sm text-[var(--color-primary,#3b82f6)] font-semibold">→</span>
              </div>
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default DisclosuresPanel;
